/**
 * 裝置判定 hook（Sprint 5-b hotfix · device-aware login routing）。
 * 手機/平板 或 PWA standalone → true，用於 login 後導向 PWA 行動版首頁。
 * 判定來源（任一成立即 true）：
 *  - viewport 寬度 ≤ 900px（MUI useMediaQuery·會隨旋轉/縮放 reactive）
 *  - PWA standalone display mode（install 後開啟）
 *  - mobile/tablet User-Agent
 */
import { useMediaQuery } from '@mui/material';

/** 非 hook 版判定（standalone + UA）· 供非 render context 使用。 */
export function detectMobileEnv(): boolean {
  const isStandalone = typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(display-mode: standalone)').matches;
  const isMobileUA = typeof navigator !== 'undefined'
    && /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(navigator.userAgent);
  // iPadOS 13+ Safari 預設「桌面版網站」·UA 自稱 Macintosh；以多點觸控辨識（Mac 無觸控）
  const isIPadDesktopUA = typeof navigator !== 'undefined'
    && /Macintosh/.test(navigator.userAgent)
    && (navigator.maxTouchPoints ?? 0) > 1;
  return Boolean(isStandalone) || isMobileUA || isIPadDesktopUA;
}

export function useIsMobile(): boolean {
  const isViewportMobile = useMediaQuery('(max-width: 900px)');
  return isViewportMobile || detectMobileEnv();
}

export default useIsMobile;
